import {apiRequest} from './api-request';
export function supportRequest(path='',body,options={}){
  return apiRequest(`/api/support${path}`,{anonymous:true,timeoutMs:20000,unavailable:'Support is temporarily unavailable. Your message is still here; please try again.',method:body?'POST':'GET',body,...options});
}
export const supportRequestId=()=>crypto.randomUUID();
